import React from 'react';
import { FormattedMessage as OriginalFormattedMessage } from 'react-intl';

const FormattedMessage = ({ id, defaultMessage, ...rest }) => {
  if (!id || typeof id !== 'string') {
    return <>{defaultMessage ?? ' '}</>;
  }

  return (
    <OriginalFormattedMessage id={id} defaultMessage={typeof defaultMessage === 'string' ? defaultMessage : undefined} {...rest} />
  );
};

export { FormattedMessage };
export default FormattedMessage;
